// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import color from "@adl/XDL/Utilities/color";
import { orderConfirmationTotalStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationTotal";
import { css } from "styled-components";

orderConfirmationTotalStyles.cartTotal = {
    container: {
        gap: 10,
        css: css`
            background-color: ${color("common.white")};
            border: 1px solid ${color("common.ui5")};
        `,
    },
    subtotalLabel: {
        size: 16,
        css: css`
            line-height: 22px;
            font-weight: 600;
        `,
    },
    subtotalValue: {
        size: 16,
        css: css`
            line-height: 22px;
            margin-left: auto;
            font-weight: 600;
        `,
    },

    totalLabel: {
        weight: "bold",
        size: 18,
        css: css`
            line-height: 22px;
        `,
    },
    totalValue: {
        weight: 900,
        size: 20,
        css: css`
            margin-left: auto;
            line-height: 28px;
        `,
    },
};
